export const appErrorCodes = new Set([400, 401, 403, 404])

// 504 is a query the API gave up on after 45 s that Postgres is still running; a retry stacks another.
export const nonRetryableErrorCodes = new Set([...appErrorCodes, 504])

export const APP_UPLOADS_ERROR_CODES = {
  GENERIC_ERROR: 'GENERIC_ERROR',
  ZOD_SCHEMA_ERROR: 'ZOD_SCHEMA_ERROR',
  DUPLICATE_ROW: 'DUPLICATE_ROW',
  // Upload-level outcomes stamped by the worker, each translated under `upload.error.*`.
  /** The job died outside its processor (killed mid-import, lock lost) and was not re-run. */
  PROCESSING_INTERRUPTED: 'PROCESSING_INTERRUPTED',
  /** At least one batch failed to save; the rest of the file went in, so the target is partial. */
  BATCH_WRITE_FAILED: 'BATCH_WRITE_FAILED',
  /** A database connection or statement timed out, typically a saturated pool under load. */
  DATABASE_TIMEOUT: 'DATABASE_TIMEOUT',
  /** The router had no processing queue for this upload's type or scope. */
  UNSUPPORTED_UPLOAD_TYPE: 'UNSUPPORTED_UPLOAD_TYPE',
}

export type AppUploadsErrorCode = keyof typeof APP_UPLOADS_ERROR_CODES
